function liveSearch() {
    var input, filter,  count = 0;
    input = $('.input--search');
    filter = $(input).val().toUpperCase();

    $('.sitemap__container-item').fadeOut(100);

    $(".sitemap ul li").each(function(){
        if ($(this).text().toUpperCase().indexOf(filter) < 0) {
            $(this).css('opacity', '0.3');
        } else {
            $(this).css('opacity', '1');
            $(this).parents('.sitemap__container-item').fadeIn(100);
            count++;
        }
    });
};

$('.search__input-clear').on('click', function () {
    $('.input--search').val('');
    $(this).fadeOut(100);
    $('.sitemap__list li, .sitemap__container-item').removeAttr('style')
})

$('.input--search').on('change, keyup', function () {
    $(this).removeClass('input--empty');
    $('.search__input-clear').fadeIn(100);
    if( $(this).val() == '' ){
        $('.search__input-clear').fadeOut(100);
        $('.sitemap__container-item').removeAttr('style');
    }
    liveSearch();
})